var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessmentPracticalIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 67,
    viewBox: "0 0 63 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.6337 0H5.37059C2.59658 0 0.345215 2.42064 0.345215 5.40322V61.5967C0.345215 64.5793 2.59658 66.9999 5.37059 66.9999H41.6337C44.4077 66.9999 46.659 64.5793 46.659 61.5967V5.40322C46.659 2.42064 44.4177 0 41.6337 0Z",
    fill: "#F09D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.6286 5.40332H6.37568C5.82289 5.40332 5.37061 5.88961 5.37061 6.48396V60.5161C5.37061 61.1105 5.82289 61.5968 6.37568 61.5968H40.6286C41.1814 61.5968 41.6337 61.1105 41.6337 60.5161V6.48396C41.6337 5.88961 41.1915 5.40332 40.6286 5.40332Z",
    fill: "#E6E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M47.6038 44.5552L50.1667 47.3L52.8301 44.4255L50.2773 41.6807",
    fill: "#D33D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.4967 0V7.3916C14.4967 8.19128 15.0997 8.85047 15.8536 8.85047H31.1608C31.9046 8.85047 32.5177 8.20208 32.5177 7.3916V0H14.4967Z",
    fill: "#5D5B68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M30.0854 0C30.0854 3.44725 27.4823 6.24612 24.2761 6.24612H14.4967V7.3916C14.4967 8.19128 15.0997 8.85047 15.8536 8.85047H31.1608C31.9046 8.85047 32.5177 8.20208 32.5177 7.3916V0H30.0854Z",
    fill: "#504F5B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M37.6133 16.9455H22.0548C21.502 16.9455 21.0497 16.4592 21.0497 15.8648C21.0497 15.2705 21.502 14.7842 22.0548 14.7842H37.6133C38.1661 14.7842 38.6184 15.2705 38.6184 15.8648C38.6184 16.4592 38.1661 16.9455 37.6133 16.9455Z",
    fill: "#848792"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.7639 21.7531H22.0548C21.502 21.7531 21.0497 21.2668 21.0497 20.6724C21.0497 20.0781 21.502 19.5918 22.0548 19.5918H33.7639C34.3167 19.5918 34.7689 20.0781 34.7689 20.6724C34.7689 21.2668 34.3167 21.7531 33.7639 21.7531Z",
    fill: "#848792"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M37.6134 34.1378H22.0549C21.5021 34.1378 21.0498 33.6516 21.0498 33.0572C21.0498 32.4629 21.5021 31.9766 22.0549 31.9766H37.6134C38.1662 31.9766 38.6185 32.4629 38.6185 33.0572C38.6185 33.6516 38.1662 34.1378 37.6134 34.1378Z",
    fill: "#848792"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.764 38.9572H22.0549C21.5021 38.9572 21.0498 38.4709 21.0498 37.8765C21.0498 37.2822 21.5021 36.7959 22.0549 36.7959H33.764C34.3168 36.7959 34.7691 37.2822 34.7691 37.8765C34.7691 38.4709 34.3168 38.9572 33.764 38.9572Z",
    fill: "#848792"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.341 13.2158H10.3959C9.84315 13.2158 9.39087 13.7021 9.39087 14.2965V21.7637C9.39087 22.3581 9.84315 22.8444 10.3959 22.8444H17.341C17.8938 22.8444 18.3461 22.3581 18.3461 21.7637V14.2965C18.3461 13.6913 17.8938 13.2158 17.341 13.2158Z",
    fill: "#6E7FED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M17.341 30.4092H10.3959C9.84315 30.4092 9.39087 30.8955 9.39087 31.4898V38.9571C9.39087 39.5514 9.84315 40.0377 10.3959 40.0377H17.341C17.8938 40.0377 18.3461 39.5514 18.3461 38.9571V31.4898C18.3461 30.8955 17.8938 30.4092 17.341 30.4092Z",
    fill: "#EE6A51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M17.341 47.6025H10.3959C9.84315 47.6025 9.39087 48.0888 9.39087 48.6832V56.1504C9.39087 56.7448 9.84315 57.2311 10.3959 57.2311H17.341C17.8938 57.2311 18.3461 56.7448 18.3461 56.1504V48.6832C18.3461 48.0888 17.8938 47.6025 17.341 47.6025Z",
    fill: "#4EC4A5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M37.6134 51.3302H22.0549C21.5021 51.3302 21.0498 50.8439 21.0498 50.2496C21.0498 49.6552 21.5021 49.1689 22.0549 49.1689H37.6134C38.1662 49.1689 38.6185 49.6552 38.6185 50.2496C38.6185 50.8439 38.1662 51.3302 37.6134 51.3302Z",
    fill: "#848792"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M33.7639 56.1496H22.0548C21.502 56.1496 21.0497 55.6633 21.0497 55.0689C21.0497 54.4746 21.502 53.9883 22.0548 53.9883H33.7639C34.3167 53.9883 34.7689 54.4746 34.7689 55.0689C34.7689 55.6633 34.3167 56.1496 33.7639 56.1496Z",
    fill: "#848792"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M40.0356 47.2459C47.0741 47.2459 52.7799 41.1111 52.7799 33.5434C52.7799 25.9757 47.0741 19.8408 40.0356 19.8408C32.9971 19.8408 27.2913 25.9757 27.2913 33.5434C27.2913 41.1111 32.9971 47.2459 40.0356 47.2459Z",
    fill: "#6E7FED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M49.0511 23.8496C48.4078 23.158 47.7143 22.5636 46.9806 22.0449C50.1968 27.3617 49.6441 34.5372 45.3021 39.2055C40.9703 43.8631 34.2865 44.4683 29.3416 41.0102C29.8139 41.7991 30.3768 42.5447 31.02 43.2363C35.9951 48.5855 44.0659 48.5855 49.0511 43.2363C54.0362 37.8872 54.0362 29.1988 49.0511 23.8496Z",
    fill: "#5F6FE7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M31.3116 34.6243C30.7588 34.6243 30.3065 34.1381 30.3065 33.5437C30.3065 30.7556 31.3216 28.1189 33.1609 26.1413C35.0002 24.1637 37.4425 23.0723 40.0457 23.0723C40.5985 23.0723 41.0508 23.5586 41.0508 24.1529C41.0508 24.7473 40.5985 25.2336 40.0457 25.2336C37.9853 25.2336 36.0455 26.0981 34.5881 27.665C33.1308 29.2319 32.3267 31.3176 32.3267 33.5329C32.3167 34.1381 31.8644 34.6243 31.3116 34.6243Z",
    fill: "#8C9FFA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M48.3978 47.6132L56.951 56.8095C58.2576 58.2143 60.3783 58.2143 61.6749 56.8095C62.9815 55.4046 62.9815 53.1245 61.6749 51.7305L53.1217 42.5342L48.3978 47.6132Z",
    fill: "#E1533B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M62.3181 52.7139C62.1673 53.2974 61.896 53.8378 61.4738 54.3024C60.1672 55.7073 58.0465 55.7073 56.75 54.3024L49.4632 46.4678L48.3978 47.6133L56.951 56.8095C58.2576 58.2144 60.3783 58.2144 61.6749 56.8095C62.7101 55.6965 62.9111 54.0539 62.3181 52.7139Z",
    fill: "#D33D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M17.341 13.2158H16.346C16.346 17.3439 13.2303 20.6939 9.39087 20.6939V21.7637C9.39087 22.3581 9.84315 22.8444 10.3959 22.8444H17.341C17.8938 22.8444 18.3461 22.3581 18.3461 21.7637V14.2965C18.3461 13.6913 17.8938 13.2158 17.341 13.2158Z",
    fill: "#5F6FE7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M17.341 30.4092H16.346C16.346 34.5372 13.2303 37.8872 9.39087 37.8872V38.9571C9.39087 39.5514 9.84315 40.0377 10.3959 40.0377H17.341C17.8938 40.0377 18.3461 39.5514 18.3461 38.9571V31.4898C18.3461 30.8955 17.8938 30.4092 17.341 30.4092Z",
    fill: "#E1533B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M17.341 47.6025H16.346C16.346 51.7306 13.2303 55.0806 9.39087 55.0806V56.1504C9.39087 56.7448 9.84315 57.2311 10.3959 57.2311H17.341C17.8938 57.2311 18.3461 56.7448 18.3461 56.1504V48.6832C18.3461 48.0888 17.8938 47.6025 17.341 47.6025Z",
    fill: "#30AA87"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M12.8785 20.7053C12.6171 20.7053 12.3659 20.5973 12.1649 20.392L11.1698 19.3329C10.7779 18.9115 10.7779 18.2307 11.1698 17.8092C11.5618 17.3878 12.195 17.3878 12.587 17.8092L12.8684 18.1118L15.1298 15.6803C15.5218 15.2589 16.155 15.2589 16.547 15.6803C16.939 16.1018 16.939 16.7826 16.547 17.2041L13.582 20.392C13.4011 20.5973 13.1398 20.7053 12.8785 20.7053Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M12.8785 37.8977C12.6171 37.8977 12.3659 37.7897 12.1649 37.5843L11.1698 36.5253C10.7779 36.1039 10.7779 35.423 11.1698 35.0016C11.5618 34.5801 12.195 34.5801 12.587 35.0016L12.8684 35.3042L15.1298 32.8727C15.5218 32.4513 16.155 32.4513 16.547 32.8727C16.939 33.2942 16.939 33.975 16.547 34.3964L13.582 37.5843C13.4011 37.7897 13.1398 37.8977 12.8785 37.8977Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M15.2906 52.4219L16.0645 51.5898C16.4565 51.1683 16.4565 50.4875 16.0645 50.0661C15.6726 49.6446 15.0394 49.6446 14.6474 50.0661L13.8735 50.8982L13.0996 50.0661C12.7076 49.6446 12.0744 49.6446 11.6824 50.0661C11.2904 50.4875 11.2904 51.1683 11.6824 51.5898L12.4563 52.4219L11.6824 53.254C11.2904 53.6754 11.2904 54.3562 11.6824 54.7777C11.8834 54.9938 12.1347 55.0911 12.396 55.0911C12.6573 55.0911 12.9086 54.983 13.1096 54.7777L13.8835 53.9456L14.6574 54.7777C14.8584 54.9938 15.1097 55.0911 15.371 55.0911C15.6324 55.0911 15.8836 54.983 16.0846 54.7777C16.4766 54.3562 16.4766 53.6754 16.0846 53.254L15.2906 52.4219Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentPracticalIcon);
export default __webpack_public_path__ + "static/media/AssessmentPracticalIcon.77edc50cd2ba3052a39a973f238f9507.svg";
export { ForwardRef as ReactComponent };